import { forwardRef } from "react";
function SvgRawChevronThinRightIcon({ title, titleId, ...props }, ref) {
  return (
    <svg
      xmlns="http://www.w3.org/2000/svg"
      width={11}
      height={18}
      fill="none"
      role="img"
      ref={ref}
      aria-labelledby={titleId}
      {...props}
    >
      {title ? <title id={titleId}>{title}</title> : null}
      <path stroke="currentColor" strokeWidth={2} d="m1 1 8 8-8 8" />
    </svg>
  );
}
const ForwardRef = forwardRef(SvgRawChevronThinRightIcon);
export default ForwardRef;
